// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AdminImportCreate__View[data-v-55b08370] {\n  padding: 20px;\n}\nh1[data-v-55b08370] {\n  font-size: 25px;\n  padding: 5px 0 20px 0;\n}\n.field[data-v-55b08370] {\n  width: 400px;\n}\n[data-v-55b08370] .switch {\n  direction: ltr;\n}\n", ""]);
// Exports
module.exports = exports;
